module.exports = __webpack_public_path__ + "static/img/TT.ec5b7686.svg";